<template>
<div class="cmp cmp-evaluate-project-teacher">
  <div class="students-list">
    <template v-for="(v,i) in myProjectEvaluate">
      <div v-if="v.type === 'seat'" class="students-item students-item-empty" :key="i"></div>
      <studentCard4 v-else class="students-item" :data="v" :key="i" @update="getProjectEvaluate"></studentCard4>
    </template>
    <div v-if="myProjectEvaluate.length===0" class="nodata nodata-rates"></div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import studentCard4 from './student-card-4.vue'
import publicUrl from '@/assets/js/interface'
import utils from '@/assets/js/utils.js'

export default {
  name: 'cmp-evaluate-project-teacher',
  components: {
    studentCard4
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      projectEvaluate: [],
      loadingCount: 0
    }
  },
  computed: {
    ...mapGetters({
      classActive: 'classmanagement/classActive',
    }),
    myProjectEvaluate () {
      // let projectEvaluate = utils.deepCopy(this.projectEvaluate)
      // let arr = projectEvaluate.map(item => {
      //   let result = {}
      //   let {correctNum, totalNum} = item.quizRecord || {}
      //   result.quizRecord = {
      //     title: '课堂小测', value: '',
      //     content: correctNum === -1 ? '未提交' : `正确${correctNum || 0}/${totalNum || 0}`,
      //   }
      //   result.questionnaire = {
      //     title: '课堂问卷', value: item.questionnaireNum,
      //     content: item.questionnaireNum === -1 ? '未提交' : `提交${item.questionnaireNum || 0}次`,
      //   }
      //   result.topic = {
      //     title: '主题讨论', value: item.topicNum,
      //     content: item.topicNum === -1 ? '未发送' : `发送${item.topicNum || 0}条`,
      //   }
      //   result.groupChat = {
      //     title: '组内聊天', value: item.groupChatNum,
      //     content: item.groupChatNum === -1 ? '未发送' : `发送${item.groupChatNum || 0}条`,
      //   }
      //   let workRecordStar = item.workRecordStar || []
      //   let content = '未评价'
      //   if (workRecordStar.length) {
      //     content = `${Math.floor(workRecordStar.reduce((a, b) => a + b) / workRecordStar.length) || 0}星`
      //   }
      //   result.workRecord = {
      //     title: '课堂作业', value: '',
      //     // content: item.workRecordStar === -1 ? '未评价' : `${item.workRecordStar || 0}星`,
      //     content
      //   }
      //   result.teacherStar = item.teacherStar || 0
      //   result.studentName = item.studentName || ''
      //   result.headPhoto = item.headPhoto || '00'
      //   return result
      // })
      let arr = utils.deepCopy(this.projectEvaluate)
      return utils.listWith(arr, 2)
    }
  },
  created () {
    if (this.$route.query.projectId) {
      this.getProjectEvaluate()
    }
  },
  methods: {
    getProjectEvaluate () {
      this.loadingCount++
      this.projectEvaluate = []
      this.$ajax.get(publicUrl.projectEvaluate, {
        params: {
          projectId: this.$route.query.projectId,
          classId: this.classActive.id,
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.projectEvaluate = res.data.data || []
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cmp-evaluate-project-teacher {
  .students-list {
    display: flex;
    flex-wrap: wrap;
    .students-item-empty {
      height: 1px;
      width: 584px;
      margin: 0 auto;
      visibility: hidden;
    }
  }
}
</style>
